import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import clsx from 'clsx'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      marginTop: 200,
    },
    centered: {
      margin: 0,
      alignItems: 'center',
      '& .MuiCircularProgress-root': {
        margin: 0,
      },
    },
    wrapper: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      display: 'flex',
      justifyContent: 'center',
    },
  }),
)

interface IProps {
  className?: string
  wrapperClassName?: string
  centered?: boolean
  size?: number
}

const StarRating: FC<IProps> = ({
  className,
  wrapperClassName,
  centered,
  size = 40,
}) => {
  const classes = useStyles()

  return (
    <div
      className={clsx(
        classes.wrapper,
        centered && classes.centered,
        wrapperClassName && wrapperClassName,
      )}
    >
      <CircularProgress
        className={clsx(classes.root, className && className)}
        size={size}
      />
    </div>
  )
}

export default StarRating
